export default __webpack_public_path__ + "static/media/3_en.caf02423.png";